"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.downloadExportFile = downloadExportFile;
exports.exportCoreData = exportCoreData;
exports.queryCoreDataHistory = queryCoreDataHistory;
exports.queryExportRecord = queryExportRecord;
exports.queryList = queryList;
var _request = _interopRequireDefault(require("@/utils/request"));
function queryList(data) {
  return (0, _request.default)({
    url: '/portal/system/dataWarehouse/memberData',
    method: 'post',
    data: data
  });
}

// 核心数据统计-历史查询
function queryCoreDataHistory(data) {
  return (0, _request.default)({
    url: '/portal/system/bi/history/query',
    method: 'post',
    data: data
  });
}

// 核心数据统计-导出
function exportCoreData(data) {
  return (0, _request.default)({
    url: '/portal/system/bi/export',
    method: 'post',
    data: data
  });
}

// 数据导出记录查询
function queryExportRecord(data) {
  return (0, _request.default)({
    url: '/portal/system/file/record/query',
    method: 'post',
    data: data
  });
}

// 数据导出文件下载
function downloadExportFile(data) {
  return (0, _request.default)({
    url: '/portal/system/file/record/download',
    method: 'post',
    data: data
  });
}